import React from "react";

const VARIANTS = {
  wordmark: { src: "/img/logo/logo.png", width: 600, height: 97 },
  icon: { src: "/img/logo/icon.png", width: 435, height: 383 },
};

/**
 * Logo Chinexpress — `variant="wordmark"` (mot complet) ou `variant="icon"` (marque seule).
 * `className` pilote la hauteur ; la largeur suit le ratio.
 */
const BrandLogo = ({ variant = "wordmark", className = "h-[22px]" }) => {
  const { src, width, height } = VARIANTS[variant] || VARIANTS.wordmark;

  return (
    <img
      src={src}
      alt="Chinexpress"
      className={`w-auto select-none ${className}`}
      width={width}
      height={height}
      draggable="false"
    />
  );
};

export default BrandLogo;
